import React from "react";
import { Input } from "@/components/ui/input";
import { CAT_ORDER } from "./util";

export default function HabitsForm({ meta, value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const spends = value.spends || {};
  const prefs = value.preferences || [];
  return (
    <div className="space-y-5" data-testid="cl-habits-form">
      <div>
        <div className="text-xs font-black uppercase tracking-wider text-stone-500 mb-2">Estimated monthly spend (₹)</div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {CAT_ORDER.map((k) => (
            <label key={k} className="rounded-xl border border-stone-200 bg-white px-3 py-2 focus-within:border-[#0B4D3A] transition-colors">
              <div className="text-[11px] font-bold text-stone-500">{meta.categories[k]}</div>
              <input type="number" min="0" step="500" value={spends[k] || ""} placeholder="0" onChange={(e) => set({ spends: { ...spends, [k]: Number(e.target.value) || 0 } })}
                className="w-full font-display font-black text-lg outline-none bg-transparent" data-testid={`cl-spend-${k}`} />
            </label>
          ))}
        </div>
      </div>
      <div>
        <div className="text-xs font-black uppercase tracking-wider text-stone-500 mb-2">What do they love to earn?</div>
        <div className="flex flex-wrap gap-2">
          {Object.entries(meta.preferences).map(([k, l]) => {
            const on = prefs.includes(k);
            return <button key={k} type="button" onClick={() => set({ preferences: on ? prefs.filter((p) => p !== k) : [...prefs, k] })} data-testid={`cl-pref-${k}`}
              className={`rounded-full px-3.5 py-2 text-xs font-bold border transition-colors ${on ? "bg-[#0B4D3A] text-white border-[#0B4D3A]" : "bg-white text-stone-600 border-stone-200 hover:border-[#0B4D3A]"}`}>{l}</button>;
          })}
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <label className="text-xs font-bold text-stone-500">Annual income (₹)
          <Input type="number" min="0" value={value.income_annual || ""} onChange={(e) => set({ income_annual: Number(e.target.value) || null })} className="mt-1 rounded-full" data-testid="cl-income" />
        </label>
        <label className="text-xs font-bold text-stone-500">Age
          <Input type="number" min="18" max="80" value={value.age || ""} onChange={(e) => set({ age: Number(e.target.value) || null })} className="mt-1 rounded-full" data-testid="cl-age" />
        </label>
        <label className="text-xs font-bold text-stone-500">Annual fee they're OK with
          <select value={value.fee_tolerance || "any"} onChange={(e) => set({ fee_tolerance: e.target.value })} className="mt-1 h-10 w-full border border-stone-200 rounded-full px-3 text-sm bg-white text-stone-800" data-testid="cl-fee-tolerance">
            {Object.entries(meta.fee_tolerance).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
      </div>
    </div>
  );
}
